import React from 'react'
import { NavLink } from 'react-router-dom'



export const MenuItems = () => {
  return (
    <ul>
              <NavLink 
              style={{color:'white', fontSize:'20px',textDecoration:'None'}}
              to={"/dispositivos"} className={"navLink"}>Dispositivos</NavLink>
              <NavLink 
              style={{color:'white', fontSize:'20px',textDecoration:'None'}}
              to={"/mapa"} className={"navLink"}>Mapa</NavLink>
              <NavLink 
              style={{color:'white', fontSize:'20px',textDecoration:'None'}}
              to={"/usuarios"} className={"navLink"}>Usuarios</NavLink>
              <NavLink 
              style={{color:'white', fontSize:'20px',textDecoration:'None'}}
              to={"/cambiarClave"} className={"navLink"}>Cambiar Clave</NavLink>
              <NavLink 
              style={{color:'white', fontSize:'20px',textDecoration:'None'}}
              to={"/logout"} className={"navLink"}>Logout</NavLink>
            </ul>
  )
}
